export default function VisitanosSection() {
  return null;
}
